module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-3-410b63c5874e550043d3056e7563909d.svg";